module.exports = __webpack_public_path__ + "static/media/Organised.4d50a6fa.png";